import React, { useState } from 'react';

const SubUsersList = ({ subUsers = [] }) => {
  if (!subUsers.length) return <div className="text-sm text-gray-500">No sub-users</div>;
  return (
    <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-2">
      {subUsers.map((s) => (
        <div key={s.docId || s.user_bid_id} className="flex items-center justify-between bg-gray-50 p-2 rounded">
          <div>
            <div className="font-medium">{s.sub_username ?? `Bidder ${s.user_bid_id}`}</div>
            <div className="text-xs text-gray-500">Bidder ID: {s.user_bid_id}</div>
            <div className="text-xs text-gray-400">Doc: {s.docId}</div>
          </div>
          <div className="text-sm font-semibold">{s.bidsCount ?? s.bids ?? 0}</div>
        </div>
      ))}
    </div>
  );
};

const UsersOverviewTable = ({ users = [],onSelectAdmin  }) => {
  const [expanded, setExpanded] = useState({});
  const toggle = (uid) => setExpanded((p) => ({ ...p, [uid]: !p[uid] }));

  return (
    <div className="bg-white p-4 rounded shadow mb-6">
      <h2 className="text-lg font-semibold mb-3">Admins / Users Overview</h2>

      <div className="rounded overflow-hidden border">
        <div className="bg-blue-600 text-white text-sm font-semibold grid grid-cols-3 px-4 py-3">
          <div>Admin</div>
          <div className="text-center">No of Bidders</div>
          <div className="text-center">No of Projects Bidded</div>
        </div>

        <div>
          {users.map((u) => (
            <div key={u.uid} className="border-b last:border-b-0">
              <button
                onClick={() => { toggle(u.uid); onSelectAdmin?.(u.uid, u.profile?.name || u.profile?.email); }}
                className="w-full text-left px-4 py-3 flex items-start justify-between gap-4"
              >
                <div className="flex-1">
                  <div className="font-medium">{u.profile?.name ?? u.profile?.email ?? u.uid}</div>
                  <div className="text-xs text-gray-500">{u.profile?.email}</div>
                </div>
                <div className="w-36 text-center text-sm">{u.subUsersCount ?? (u.subUsers?.length ?? 0)}</div>
                <div className="w-36 text-center text-sm">{u.totalBidsByUser ?? 0}</div>
              </button>

              {expanded[u.uid] && (
                <div className="px-4 pb-3">
                  <div className="text-xs text-gray-500 mb-2">Sub-users</div>
                  <SubUsersList subUsers={u.subUsers || []} />
                </div>
              )}
            </div>
          ))}
          {users.length === 0 && <div className="px-4 py-6 text-sm text-gray-500">No overview data available.</div>}
        </div>
      </div>
    </div>
  );
};

export default UsersOverviewTable;